import { Box, Grid } from "@mui/material";
import ThemeContext from "components/app/Context";
import Feedback from "components/common/Feedback";
import NoPlansBanner from "components/common/NoPlansBanner";
import Scroller from "components/common/Scroller/InfiniteScroller";
import Spinner from "components/common/Spinner/Spinner";
import { isEmpty } from "lodash";
import { useContext, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { PAGE_SIZE } from "utils/CommonConstants";
import { pageNames } from "utils/Types";
import TableHeader from "./TableHeader";
import Item from "./item";
import { clearMyPlanList, fetchMyPlansAsync, fetchOwnerDetailsAsync } from "./myplans.slice";

interface Props {
  filters: any;
  searchText?: string;
}

function List(props: Props) {
  const { searchText, filters } = props;
  const myPlansList: any = useAppSelector((state) => state?.myplans.MyPlans.list);
  const isLoading: any = useAppSelector((state) => state?.myplans.MyPlans.status);
  const totalRecords: any = useAppSelector((state) => state.myplans.MyPlans.totalRecords);
  const isAdmin = useAppSelector((state) => state.app.isAdmin);
  const [pageNo, setPageNo] = useState(0);
  const bookMarkInncodes = useAppSelector((state) => state.Dashboard.bookMarkInncodes);
  const dispatch = useAppDispatch();
  const { isMobileScreen } = useContext(ThemeContext);

  useEffect(() => {
    const shouldFetchPlans = isAdmin ? !(isEmpty(filters.innCode) && isEmpty(filters.searchedHltId)) : true;

    if (isEmpty(filters)) return;
    if (isAdmin && isEmpty(filters.innCode) && isEmpty(filters.searchedHltId)) {
      dispatch(clearMyPlanList());
      return;
    }
    const getPlans = async () => {
      let planOwners: [] = [];
      const props = {
        page: 0,
        size: PAGE_SIZE,
        searchText: searchText,
        ...filters
      };

      const fetchPlans = await dispatch(fetchMyPlansAsync(props));
      planOwners = fetchPlans?.payload?.meta?.owners;
      if (planOwners?.length > 0) {
        const data = {
          value: planOwners,
          size: planOwners.length
        };
        dispatch(fetchOwnerDetailsAsync(data));
      }
    };
    if (shouldFetchPlans) getPlans();
    setPageNo(0);
  }, [dispatch, filters, searchText, isAdmin, bookMarkInncodes]);

  const fetchMore = () => {
    const props = {
      page: pageNo + 1,
      size: PAGE_SIZE,
      searchText: searchText,
      ...filters
    };
    dispatch(fetchMyPlansAsync(props));
    setPageNo(pageNo + 1);
  };

  return (
    <>
      <Feedback form="fetchMyPlans" />

      {!isMobileScreen && <TableHeader />}
      {isLoading === "idle" || pageNo > 0 ? (
        <Grid container marginTop={isMobileScreen ? "-40px" : "0px"}>
          {myPlansList?.length ? (
            <Scroller dataLength={myPlansList.length} loadMore={fetchMore} totalList={totalRecords} label="Plans">
              {myPlansList.map((plan: any) => {
                return <Item key={plan.id} plan={plan} />;
              })}
            </Scroller>
          ) : (
            <NoPlansBanner pageName={pageNames.myPlans} />
          )}
        </Grid>
      ) : (
        <Box width={"500px"} marginTop={"100px"}>
          <Spinner backdropVisible />
        </Box>
      )}
    </>
  );
}

export default List;
